// Utility functions for toast notifications
// Uses the React-based toast system when available

let toastContext = null;

// Function to set the toast context (called by the provider)
export const setToastContext = (context) => {
  toastContext = context;
};

export const showToast = (message, type = 'info', duration = 3000) => {
  if (toastContext) {
    return toastContext.addToast(message, type, duration);
  }
  console.warn('Toast system not initialized');
};

export const showSuccess = (message) => showToast(message, 'success');
export const showError = (message) => showToast(message, 'error');
export const showInfo = (message) => showToast(message, 'info');
